(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-gifts/assets/javascripts/redeem/index.js') >= 0) return;  svs.modules.push('/modules/ticket-gifts/assets/javascripts/redeem/index.js');
"use strict";


const Redeem = _ref => {
  let {
    voucherData,
    history,
    match,
    isPlayer,
    numberOfTickets,
    totalPrice
  } = _ref;
  const AuthorizedLanding = svs.ticket_gifts.redeem.components.AuthorizedLanding;
  const UnauthorizedLanding = svs.ticket_gifts.redeem.components.UnauthorizedLanding;
  React.useEffect(() => {
    if (isPlayer && history.location.search) {
      history.replace(history.location.pathname, history.location.pathname);
    }
  }, [history, isPlayer]);
  return isPlayer ? React.createElement(AuthorizedLanding, {
    history: history,
    match: match,
    voucherData: voucherData
  }) : React.createElement(UnauthorizedLanding, {
    history: history,
    numberOfTickets: numberOfTickets,
    totalPrice: totalPrice
  });
};
setGlobal('svs.ticket_gifts.redeem.components.Redeem', Redeem);

 })(window);